import React from 'react';

export interface TextProps {
  children: React.ReactNode;
  className?: string;
  variant?:
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'p'
    | 'blockquote'
    | 'span'
    | 'div';
  size?: string;
}
const Text: React.FC<TextProps> = ({
  children,
  className,
  variant = 'p',
  size,
}) => {
  const Element: React.ElementType = variant;
  let additionalClasses = 'font-readexProRegular';

  const variantSizeMap: Record<string, string> = {
    h1: 'text-6xl',
    h2: 'text-5xl',
    h3: 'text-4xl',
    h4: 'text-3xl',
    h5: 'text-2xl',
    h6: 'text-xl',
    p: 'text-base',
    blockquote: 'text-base',
    div: '',
  };

  additionalClasses += ` ${variantSizeMap[variant] || ''}`;

  const tailwindSizes = [
    '2xs',
    'xs',
    'sm',
    'base',
    'lg',
    'xl',
    '2xl',
    '3xl',
    '4xl',
    '5xl',
    '6xl',
    '7xl',
    '8xl',
    '9xl',
    '10xl',
    '11xl',
    '12xl',
    '13xl',
  ];

  let style = {};
  if (size) {
    if (tailwindSizes.includes(size)) {
      additionalClasses += ` text-${size}`;
    } else {
      style = { fontSize: size };
    }
  }

  const combinedClasses = `${additionalClasses} ${className || ''}`.trim();

  return (
    <Element
      className={combinedClasses}
      style={style}
    >
      {children}
    </Element>
  );
};

export { Text };
